// extracted by mini-css-extract-plugin
export const card = "styles-module--card--z2uub";
export const logo = "styles-module--logo--NSj35";
export const txtName = "styles-module--txtName--wT3EF";
export const btn = "styles-module--btn--1hrFX";